// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import logger from "@insite/client-framework/Logger";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import setCustomProductState from "@steiner/App/Handlers/ProductDetails/SetCustomProductState";
import { getProductBoxes, ProductBoxesResponse } from "@steiner/App/Services/ProductService";
import { CustomAppState } from "@steiner/App/Store/Reducers";

export interface LoadProductBoxesParameter extends ApiParameter {
    productId: string;
}

type HandlerType = ApiHandler<LoadProductBoxesParameter, ProductBoxesResponse>;

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try {
        props.apiResult = await getProductBoxes(props.parameter.productId);
    } catch (error) {
        return false;
    }
};

export const DispatchCompleteLoadProductBoxesData: HandlerType = props => {
    if (props.apiResult.productBoxes) {
        let customProductState = (props.getState() as CustomAppState).xProductDetails.byId[props.parameter.productId];
        customProductState = {
            boxes: props.apiResult.productBoxes,
            ...customProductState,
        };
        props.dispatch(setCustomProductState({ customProductStates: [customProductState] }));
    }
};

export const chain = [PopulateApiParameters, RequestDataFromApi, DispatchCompleteLoadProductBoxesData];

const loadProductBoxes = createHandlerChainRunner(chain, "loadProductBoxes");

export default loadProductBoxes;
